import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import styled from 'styled-components';

const HeaderSidebarDropdownButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  #hsbd-dropdown-btn-continer {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    font-size: 1.8rem;
    padding: 0.5rem 1rem;
    width: fit-content;
    word-wrap: wrap none;
    text-align: left;
    height: 100%;
    cursor: pointer;
    color: var(--color-battleship_grey);
    text-decoration: none;
    #hsbd-title {
      border-bottom: 1.5px solid transparent;
      &:hover {
        border-bottom: 1.5px solid transparent;
      }
    }
    #hsbd-chevron-up,
    #hsbd-chevron-down {
      font-size: 1.6rem;
      margin-left: 1rem;
    }
  }
`;

const HeaderSidebarDropdownButton = ({ title, component }) => {
  const [dropdown, setDropdown] = useState(false);

  return (
    <HeaderSidebarDropdownButtonWrapper>
      <div id="hsbd-dropdown-btn-continer" onClick={() => setDropdown(!dropdown)}>
        <div id="hsbd-title">{title}</div>
        <div>
          {dropdown ? (
            <div id="hsbd-chevron-up">
              <FontAwesomeIcon icon="chevron-up" />
            </div>
          ) : (
            <div id="hsbd-chevron-down">
              <FontAwesomeIcon icon="chevron-down" />
            </div>
          )}
        </div>
      </div>
      {dropdown ? component : null}
    </HeaderSidebarDropdownButtonWrapper>
  );
};

export default HeaderSidebarDropdownButton;
